<script>
export default {
  name: 'ActionButtonGroup',
};
</script>

<template>
  <div class="gl-display-flex gl-align-items-center gl-justify-content-end gl-mx-n1">
    <slot></slot>
  </div>
</template>
